import CV from './CV'

export default CV
